import Axios from 'axios'
import { API_HOST_TOKEN } from 'constants/appConstants'
import {
  GET_BY_ID,
  GET_EVENTS_LIST,
  GET_EVENTS_TYPE_LIST,
  GET_FEATURED_CONTENT,
  GET_LIST,
  GET_UPCOMING_EVENTS,
  GET_SEARCH,
} from 'constants/restConstants'

const config = {
  headers: { Authorization: `Bearer ${API_HOST_TOKEN}` },
}

export const getList = (contentType, currPage = 1, zone) => Axios.get(GET_LIST(contentType, currPage, zone), config)

export const getEventsTypeList = (contentType, currPage = 1, zone) =>
  Axios.get(GET_EVENTS_TYPE_LIST(contentType, currPage, zone), config)

export const getEventsList = (currPage = 1, zone) => Axios.get(GET_EVENTS_LIST(currPage, zone), config)

export const getFeaturedContent = screenId => Axios.get(GET_FEATURED_CONTENT(screenId), config)

export const getUpcomingEvents = zone => Axios.get(GET_UPCOMING_EVENTS(zone), config)

export const getById = (contentType, documentId) => Axios.get(GET_BY_ID(contentType, documentId), config)

export const getSearch = (zone, query) => Axios.get(GET_SEARCH(zone, query), config)
